<template>
    <v-container fluid class="pa-0">
        <PageHeader :contextStyle="contextStyle">
            <template #right v-if="( $route.params.equ_id == undefined )">
                <v-btn small rounded color="primary" :to="{ name: 'equipments-edit', params: { equ_id: 0 } }">Ajouter</v-btn>
            </template>
        </PageHeader>
    
        <ItemForm v-if="( $route.params.equ_id !== undefined && parseInt( $route.params.equ_id ) >= 0 )"/>
        <v-card v-else :class="($root.$mobileView) ? 'mt-0 mb-2 ml-0 mr-0 rounded-lg' : 'ma-4 rounded-lg'">
            <ItemList />
        </v-card>
    
    </v-container>
</template>

<script>
import PageHeader from '@/components/ui/PageHeader'
import ItemForm        from '@/components/equipments/EquipmentForm.vue'
import ItemList        from '@/components/equipments/EquipmentList.vue'

export default {
    name: 'equipments-page',
    props: ['contextStyle'],
    components: { PageHeader, ItemForm, ItemList },
    data: function () {
        return {
            
        }
    },
    computed: {

    },
    mounted: function (){

    },
    methods: {
        
    }
}
</script>